import { apiClient } from '@core/api/ApiClientFactory';
import type { NotificationTemplate, MediaPlayerTemplate } from './types';

export const templateService = {
    // Notification Templates
    async loadTemplates(): Promise<NotificationTemplate[]> {
        try {
            const response = await apiClient.get<NotificationTemplate[]>('template');
            return response.data;
        } catch (error) {
            console.error('[TemplateService] Error loading templates:', error);
            throw error;
        }
    },

    async saveNotificationTemplate(item: NotificationTemplate): Promise<NotificationTemplate> {
        try {
            if (item?.id) {
                const response = await apiClient.put<NotificationTemplate>(`template/${item.id}`, item);
                return response.data;
            }
            const response = await apiClient.post<NotificationTemplate>('template', (({ id, ...rest }) => rest)(item));
            return response.data;
        } catch (error) {
            console.error('[TemplateService] Error saving notification template:', error);
            throw error;
        }
    },

    async deleteTemplate(id: string): Promise<void> {
        try {
            await apiClient.delete(`template/${id}`);
            return;
        } catch (error) {
            console.error('[TemplateService] Error deleting template:', error);
            throw error;
        }
    },

    // Media Player Templates
    async loadMediaPlayerTemplates(): Promise<MediaPlayerTemplate[]> {
        try {
            const response = await apiClient.get<MediaPlayerTemplate[]>('mediaPlayerType');
            return response.data;
        } catch (error) {
            console.error('[TemplateService] Error loading media player templates:', error);
            throw error;
        }
    },

    async saveMediaPlayerTemplate(item: MediaPlayerTemplate): Promise<MediaPlayerTemplate> {
        try {
            if (item?.id) {
                const response = await apiClient.put<MediaPlayerTemplate>(`mediaPlayerType/${item.id}`, item);
                return response.data;
            }
            const response = await apiClient.post<MediaPlayerTemplate>(
                'mediaPlayerType',
                (({ id, ...rest }) => rest)(item)
            );
            return response.data;
        } catch (error) {
            console.error('[TemplateService] Error saving media player template:', error);
            throw error;
        }
    },

    async deleteMediaPlayerTemplate(id: string): Promise<void> {
        try {
            await apiClient.delete(`mediaPlayerType/${id}`);
            return;
        } catch (error) {
            console.error('[TemplateService] Error deleting media player template:', error);
            throw error;
        }
    }
};
